var map = {
	"./Kitemill om sikker energiforsyning og bærekraft.mp4": "9edb",
	"./NorCod med i TERRAVERA Business Program.mp4": "7de0",
	"./OPUS blir en del av TERRAVERA Business Program.mp4": "f7d2",
	"./ScaleAQ - ny deltaker i TERRAVERA Business Program.mp4": "1082",
	"./default.mp4": "1176"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cf0d";